module.exports = require('./helpers/bundle-url').getBundleURL('gaxWV') + "logo.92d607e0.svg";